import { AnnouncementInterface } from '@careapp/angular-sdk';

import { CareAppListActionFactory } from './action-factory';

class AnnouncementActions extends CareAppListActionFactory<AnnouncementInterface> {
  get PROMPT_EDIT() {
    return `[${this.type}][Prompt] Edit`;
  }

  get PROMPT_DELETE() {
    return `[${this.type}][Prompt] Delete`;
  }

  PromptEdit(payload: AnnouncementInterface) {
    return {
      type: this.PROMPT_EDIT,
      payload
    };
  }

  PromptDelete(payload: AnnouncementInterface) {
    return {
      type: this.PROMPT_DELETE,
      payload
    };
  }

  constructor() {
    super(`Announcements`);
  }
}
export const Announcements = new AnnouncementActions();
